/**
 * Gift Stock Progress Bar Component
 * 礼品库存进度条组件
 */
class GiftStockProgressBar extends HTMLElement {
  constructor() {
    super();
    // 使用motion.inView来在元素进入视口时触发动画
    motion.inView(this, this.init.bind(this), { margin: '0px 0px -10px 0px' });
  }
  
  init() {
    const currentStock = Number(this.dataset.currentStock);
    const maxStock = Number(this.dataset.maxStock);
    
    if (!currentStock || !maxStock) return;
    
    // 计算进度百分比
    let progress = (currentStock / maxStock) * 100;
    if (progress > 100) progress = 100;
    
    // 更新库存数量显示
    this.updateStockMessage(currentStock);
    
    // 延迟启动进度条动画
    setTimeout(() => {
      this.setProgressBar(progress);
    }, 200);
  }
  
  setProgressBar(progress) {
    const progressBar = this.querySelector('.gift_percent_bar');
    if (progressBar) {
      // 先设置为100%，然后动画到目标百分比
      progressBar.style.width = '100%';
      
      setTimeout(() => {
        progressBar.style.width = progress + '%';
      }, 100);
    }
  }
  
  updateStockMessage(currentStock) {
    const stockCount = this.querySelector('.gift-stock-count');
    if (stockCount) {
      stockCount.textContent = currentStock;
    }
  }
}

// 注册自定义元素
customElements.define('gift-stock-progress-bar', GiftStockProgressBar); 